// Normalizes color names by title-casing each word and uppercasing roman numerals for consistent display.
export const normalizeColorName = (value: string | null | undefined) => {
  if (!value) return value;

  return value
    .trim()
    .split(/\s+/)
    .map(word => {
      if (/^[ivxlcdm]+$/i.test(word)) {
        return word.toUpperCase();
      }

      const lower = word.toLowerCase();
      return lower.charAt(0).toUpperCase() + lower.slice(1);
    })
    .join(' ');
};
